import { CoreLink } from '@uncinc/react-drupal-core';
import Truncate from 'react-truncate';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

import './style.scss';

const SearchResult = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed']);
  const summary = entity.getIn(['body', 0, 'summary']);
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));
  const path = entity.getIn(['paths', currentLanguage]);

  return (
    <article
      className="SearchResult"
    >
      <div className="SearchResult__title">
        <CoreLink to={path}>
          <h2>{title}</h2>
        </CoreLink>
      </div>
      <div className="SearchResult__body">
        <Truncate lines={2} ellipsis="...">
          <WysiwygField
            property="schema:text"
            html={(summary !== '' ? summary : body)} />
        </Truncate>
      </div>
    </article>
  );
};

export default SearchResult;
